module.exports = __webpack_public_path__ + "static/img/3neiwaiye.565fd050.jpg";